import Vue from 'vue'
import Vuex from 'vuex'

import user from './user.module'
import category from './category.module'
import tld from './tld.module'
import tag from './tag.module'
import filter from './filter.module'
import website from './website.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    category,
    tld,
    tag,
    filter,
    website
  }
})